export default "__VITE_ASSET__616ef8db__"